import * as React from 'react';
import { LocalizedDateTime, DateTimeAccuracy } from '../../../misc/components/LocalizedDateTime';
import { AnalysisAcceptabilityStatus } from '../../../misc/components/analysis/AnalysisAcceptabilityStatus';

export interface AnalysisSetCardProps {
    id: string;
    type: string;
    disabled: boolean;
    createdDateTime: string;
    analyst: string;
    acceptability: string;
    checked: boolean;
    onAnalysisSetSelect: (checked: boolean) => void;
}

export default class AnalysisSetCard extends React.Component<AnalysisSetCardProps> {
    constructor(props: AnalysisSetCardProps) {
        super(props);
    }

    renderAnalyst = () => {
        if (this.props.analyst) {
            return <div><i className="fas fa-user"></i> {this.props.analyst}</div>;
        } else {
            return null;
        }
    }

    render() {
        const currentIndicatorLabel = this.props.disabled ? <span className="label label-primary">Current Set</span> : null;
        const icon = this.props.disabled ? <i className="fas fa-thumbtack" aria-hidden="true"></i> : <i className="fas fa-pen-square" aria-hidden="true"></i>

        return (
            <li>
                <input id={this.props.id} type="checkbox" disabled={this.props.disabled} checked={this.props.checked} onChange={() => this.props.onAnalysisSetSelect(!this.props.checked)} />
                <label htmlFor={this.props.id}>
                    <span className="posh-select-icon">{icon}</span>
                    <span className="posh-select-body">
                        <span className="posh-select-title">{this.props.type} {currentIndicatorLabel}</span>
                        <div className="row">
                            <div className="col-md-8">
                                <div><LocalizedDateTime time={this.props.createdDateTime} accuracy={DateTimeAccuracy.Second} /></div>
                                {this.renderAnalyst()}
                            </div>
                            <div className="col-md-4">
                                <AnalysisAcceptabilityStatus value={this.props.acceptability} />
                            </div>
                        </div>
                    </span>
                </label>
            </li>
        );
    }
}
